"use client";
import { useEffect } from "react";
import { offlineContext } from "@/lib/offline/context";
import { getNativeWidgetPlugin } from "@/lib/native/widget-bridge";
import { setWidgetConditionsSource } from "@/lib/native/widget-runtime";

/** Registers the checked page owner. One persistent coordinator performs native writes. */
export function NativeWidgetSnapshotSync({ homeResortSlug, owner, disabled = false }: { homeResortSlug: string | null; owner?: string | null; disabled?: boolean }) {
  useEffect(() => {
    if (disabled || !owner || !getNativeWidgetPlugin()) return;
    let cancelled = false;
    void offlineContext().then(context => {
      if (!cancelled && context.owner === owner) setWidgetConditionsSource(context, homeResortSlug);
    }).catch(() => undefined);
    return () => { cancelled = true; };
  }, [homeResortSlug, owner, disabled]);
  return null;
}
